export default "__VITE_ASSET__CfyMjhZt__"